export const ROUTES = {
  home: '/',
  contact: '/contact',
  forCandidate: '/for-candidate',
  forCollege: '/for-college',
  forEmployer: '/for-employer',
  virtualJobFair: '/virtual-job-fair',
  virtualJobFairLogin: '/virtual-job-fair/login',
  about: '/about',
  getStarted: '/get-started',
  bookDemo: '/book-demo',
  signIn: '/sign-in',
  register: '/register',
  dashboard: '/dashboard',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms-and-conditions',
  notFound: '*',
} as const;
